import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeaveService } from './services/leave.service'
import { from } from 'rxjs';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    LeaveService
  ]
})
export class LeaveModule { }
 